export default {
  freezeScreen: {
    type: Boolean,
    default: true
  },
  state: String,
  noCloseBtn: Boolean,
  noDivider: Boolean,
  hideOnBlur: Boolean,
  show: Boolean
}


// WEBPACK FOOTER //
// ./src/components/Modal/_props.js